import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getPilotPraxisYoutubeLink = (state) => {
    return state.pilotPraxisYoutubeLink;
};
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getPilotPraxisYoutubeLink,
};
